<template>
  <div class="content full">
    <e-breadcrumbs />
    <win-layer-pop class="sample_popup_list">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <h1 class="page_title">{{ $t('cp.CTRL060P020.001') }}</h1>
    <div class="content_box mt10">
      <table class="tbl_search">
        <colgroup>
          <col width="100px">
          <col>
          <col width="90px">
          <col>
          <col width="100px">
          <col>
          <col width="100px">
        </colgroup>
        <tbody>
          <tr>
            <th>{{ $t('cp.CTRL060P020.006') }}</th>
            <td class="cp-relative">
              <input
                :id="`yearWeekPsel`"
                class="cp-psel"
                @mousedown.stop="clickPsel('yearWeek')"
                :placeholder="setPselTxt('yearWeek')"
                readonly
              >
              <div
                :id="`yearWeekPopt`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': yearWeekList?.length === 0,
                      'cp-pchkbox--selected': send.keyInput.yearWeek?.length !== 0 && (yearWeekList.length === send.keyInput.yearWeek.length)
                    }"
                    @click.prevent="controlPchk('yearWeek')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`yearWeekPoptSearch`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="yearWeekList?.length === 0">
                </div>
                <ul v-if="yearWeekList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText('yearWeek') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in yearWeekList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': send.keyInput.yearWeek.includes(item.yearWeek),
                      'cp-li--hide': searchPopt('yearWeek', item.yearWeek, item.yearWeek)
                    }"
                    @click.prevent="clickPopt('yearWeek', item.yearWeek)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': send.keyInput.yearWeek.includes(item.yearWeek)}"><span class="offscreen">No</span></label>
                    <span>{{ item.yearWeek }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P020.037') }}</th>
            <td class="cp-relative">
              <input
                :id="`territoryPsel`"
                class="cp-psel"
                @mousedown.stop="clickPsel('territory')"
                :placeholder="setPselTxt('territory')"
                readonly
              >
              <div
                :id="`territoryPopt`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': territoryList?.length === 0,
                      'cp-pchkbox--selected': send.keyInput.territory?.length !== 0 && (territoryList.length === send.keyInput.territory.length)
                    }"
                    @click.prevent="controlPchk('territory')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`territoryPoptSearch`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="territoryList?.length === 0">
                </div>
                <ul v-if="territoryList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText('territory') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in territoryList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': send.keyInput.territory.includes(item.terCd),
                      'cp-li--hide': searchPopt('territory', item.terCd, item.terCd)
                    }"
                    @click.prevent="clickPopt('territory', item.terCd)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': send.keyInput.territory.includes(item.terCd)}"><span class="offscreen">No</span></label>
                    <span>{{ item.terNm }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P020.009') }}</th>
            <td class="cp-relative">
              <input
                :id="`routePsel`"
                class="cp-psel"
                @mousedown.stop="clickPsel('route')"
                :placeholder="setPselTxt('route')"
                readonly
              >
              <div
                :id="`routePopt`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': routeList?.length === 0,
                      'cp-pchkbox--selected': send.keyInput.route?.length !== 0 && (routeList.length === send.keyInput.route.length)
                    }"
                    @click.prevent="controlPchk('route')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`routePoptSearch`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="routeList?.length === 0">
                </div>
                <ul v-if="routeList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText('route') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in routeList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': send.keyInput.route.includes(item.rteCd),
                      'cp-li--hide': searchPopt('route', item.rteCd, item.rteCd)
                    }"
                    @click.prevent="clickPopt('route', item.rteCd)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': send.keyInput.route.includes(item.rteCd)}"><span class="offscreen">No</span></label>
                    <span>{{ item.rteCd }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P020.043') }}</th>
            <td class="cp-relative">
              <input
                :id="`salesPsel`"
                class="cp-psel"
                @mousedown.stop="clickPsel('sales')"
                :placeholder="setPselTxt('sales')"
                readonly
              >
              <div
                :id="`salesPopt`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': salesList?.length === 0,
                      'cp-pchkbox--selected': send.keyInput.sales?.length !== 0 && (salesList.length === send.keyInput.sales.length)
                    }"
                    @click.prevent="controlPchk('sales')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`salesPoptSearch`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="salesList?.length === 0">
                </div>
                <ul v-if="salesList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText('sales') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in salesList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': send.keyInput.sales.includes(item.salUno),
                      'cp-li--hide': searchPopt('sales', item.salUno, item.salUno)
                    }"
                    @click.prevent="clickPopt('sales', item.salUno)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': send.keyInput.sales.includes(item.salUno)}"><span class="offscreen">No</span></label>
                    <span>{{ item.salUno }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td class="text_right">
              <a class="button blue sh" href="#" @click.prevent="select">{{ $t('cp.COMMON.001') }}</a>
            </td>
          </tr>
          <tr>
            <th>{{ $t('cp.CTRL060P020.027') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.porCtr" @change="getHarborList(param.porCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.porPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P020.007') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.polCtr" @change="getHarborList2(param.polCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.polPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList2" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <th style="width: 100px;">{{ $t('cp.CTRL060P020.008') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.podCtr" @change="getHarborList3(param.podCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.podPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList3" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <th style="width: 100px;">{{ $t('cp.CTRL060P020.028') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.dlyCtr" @change="getHarborList4(param.dlyCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.dlyPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList4" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab">
      <ul>
        <li class="on" id="tab1" @click="selectTab(1)"><a href="javascript:void(0)">{{ $t('cp.CTRL060P010.073') }}</a></li>
        <li id="tab2" @click="selectTab(2)"><a href="javascript:void(0)">{{ $t('cp.CTRL060P010.074') }}</a></li>
      </ul>
    </div>
    <div class="content_box">
      <table class="tbl">
        <tbody>
          <tr>
            <td>
              <div class="flex_box" style="margin-bottom: -7px;">
                <h2 class="content_title" style="margin-top: 10px; margin-right: auto;">{{ $t('cp.CTRL060P020.002') }}</h2>
                <input
                  type="radio"
                  id="solverGbCd_1"
                  v-model="param.solverGbCd"
                  value="1"
                  @click="select(1)"
                />
                <label for="solverGbCd_1">ALL</label>
                <input
                  type="radio"
                  id="solverGbCd_2"
                  v-model="param.solverGbCd"
                  value="2"
                  @click="select(2)"
                />
                <label for="solverGbCd_2">Success</label>
                <input
                  type="radio"
                  id="solverGbCd_3"
                  v-model="param.solverGbCd"
                  value="3"
                  @click="select(3)"
                />
                <label for="solverGbCd_3">Fail</label>
                <input
                  type="radio"
                  id="solverGbCd_4"
                  v-model="param.solverGbCd"
                  value="4"
                  @click="select(4)"
                />
                <label for="solverGbCd_4">Wait</label>
              </div>
              <div class="content_box mt13">
                <table class="tbl_col">
                  <colgroup>
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                    <col width="7.69%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>{{ $t('cp.CTRL060P020.009') }}</th>
                      <th>{{ $t('cp.CTRL060P020.039') }}</th>
                      <th>{{ $t('cp.CTRL060P020.027') }}</th>
                      <th>{{ $t('cp.CTRL060P020.040') }}</th>
                      <th>{{ $t('cp.CTRL060P020.007') }}</th>
                      <th>{{ $t('cp.CTRL060P020.041') }}</th>
                      <th>{{ $t('cp.CTRL060P020.008') }}</th>
                      <th>{{ $t('cp.CTRL060P020.042') }}</th>
                      <th>{{ $t('cp.CTRL060P020.028') }}</th>
                      <th>{{ $t('cp.CTRL060P020.010') }}</th>
                      <th>{{ $t('cp.CTRL060P020.011') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="chk"><input type="checkbox" name="no" id="chk1" v-model="param.routeYn" true-value="Y" false-value=""><label for="chk1"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk2" v-model="param.porCtrYn" true-value="Y" false-value=""><label for="chk2"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk3" v-model="param.porPlcCdYn" true-value="Y" false-value=""><label for="chk3"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk4" v-model="param.polCtrYn" true-value="Y" false-value=""><label for="chk4"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk5" v-model="param.polPlcCdYn" true-value="Y" false-value=""><label for="chk5"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk6" v-model="param.podCtrYn" true-value="Y" false-value=""><label for="chk6"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk7" v-model="param.podPlcCdYn" true-value="Y" false-value=""><label for="chk7"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk8" v-model="param.dlyCtrYn" true-value="Y" false-value=""><label for="chk8"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk9" v-model="param.dlyPlcCdYn" true-value="Y" false-value=""><label for="chk9"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk10" v-model="param.vslCdYn" true-value="Y" false-value=""><label for="chk10"><span class="offscreen">No</span></label></td>
                      <td class="chk"><input type="checkbox" name="no" id="chk11" v-model="param.voyNoYn" true-value="Y" false-value=""><label for="chk11"><span class="offscreen">No</span></label></td>
                    </tr>
                  </tbody>
                </table>
                <div id="realgrid1" v-show="tapState === 1" class="mt5" style="width: 100%; height: 467px" />
                <div id="realgrid6" v-show="tapState === 2" class="mt5" style="width: 100%; height: 467px" />
              </div>
            </td>
            <td rowspan="2">
              <div class="flex_box" style="margin-bottom: -7px;">
                <h2 class="content_title" style="margin-top: 9px;">{{ $t('cp.CTRL060P020.003') }}</h2>
                <span class="ml_auto cal_btn" style="margin-top: 10px;">
                  <a class="button sm" href="#" @click.prevent="add()">{{ $t('cp.COMMON.009') }}</a>
                  <a class="button sm ml2" href="#" @click.prevent="del()">{{ $t('cp.COMMON.010') }}</a>
                  <a class="button blue sm ml2" href="#" @click.prevent="asyncAlert($t('cp.CTRL060P020.052'))">{{ $t('cp.COMMON.004') }}</a>
                </span>
              </div>
              <div class="content_box mt10">
                <div id="realgrid2" class="mt5" style="width: 100%; height: 118px" />
              </div>
              <div class="flex_box" style="margin-bottom: -7px;">
                <h2 class="content_title" style="margin-top: 9px;">{{ $t('cp.CTRL060P020.004') }}</h2>
                <span class="ml_auto cal_btn" style="margin-top: 10px;">
                  <a v-show="bsaUser === 'Z'" class="button blue sm ml2" href="#" @click.prevent="asyncAlert3($t('cp.CTRL060P020.055'))">{{ $t('cp.CTRL060P020.054') }}</a>
                  <a class="button blue sm ml2" href="#" @click.prevent="asyncAlert2($t('cp.CTRL060P020.052'))">{{ $t('cp.COMMON.004') }}</a>
                </span>
              </div>
              <div class="content_box mt10">
                <div id="realgrid3" v-show="tapState === 1" class="mt5" style="width: 100%; height: 774px" />
                <div id="realgrid7" v-show="tapState === 2" class="mt5" style="width: 100%; height: 774px" />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex_box" style="margin-bottom: -7px;">
                <h2 class="content_title" style="margin-top: 10px;">{{ $t('cp.CTRL060P020.005') }}</h2>
                <input
                  type="radio"
                  id="gridGbCd_1"
                  v-model="gridGbCd"
                  value="1"
                />
                <label for="gridGbCd_1">PROSPECT</label>
                <input
                  type="radio"
                  id="gridGbCd_2"
                  v-model="gridGbCd"
                  value="2"
                />
                <label for="gridGbCd_2">BSA</label>
                <span class="ml_auto cal_btn" style="margin-top: 10px;">
                  기본 최저 유지 비율 <input style="width: 38px;" type="text" v-model="param.solverPercent" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" maxlength="2"> %
                  <a class="button blue sm ml2" href="#" @click.prevent="solver">{{ $t('cp.CTRL060P020.053') }}</a>
                </span>
              </div>
              <div class="content_box mt10" v-show="gridGbCd === '1'">
                <h5 class="content_title" style="display: inline;">{{ vslVoyInfo }}</h5>
                <div id="realgrid4" v-show="tapState === 1" class="mt5" style="width: 100%; height: 330px" />
                <div id="realgrid8" v-show="tapState === 2" class="mt5" style="width: 100%; height: 330px" />
              </div>
              <div class="content_box mt10" v-show="gridGbCd === '2'">
                <h5 class="content_title" style="display: inline;">{{ vslVoyInfo }}</h5>
                <div id="realgrid5" v-show="tapState === 1" class="mt5" style="width: 100%; height: 330px" />
                <div id="realgrid9" v-show="tapState === 2" class="mt5" style="width: 100%; height: 330px" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

  <script>
  import { createGrid } from '@/plugins/realgridUtil'
  import { rootComputed } from '@/store/helpers'
  import bsaAdjRvnTotal from '@/api/rest/bsa/bsaAdjRvnTotal'
  import bsaCommonInfo from '@/api/rest/bsa/bsaCommonInfo'
  import EBreadcrumbs from '@/components/common/EBreadcrumbs'
  import JSZip from 'jszip'

  window.JSZip = window.JSZip || JSZip
  let gridView1 = null
  let gridView2 = null
  let gridView3 = null
  let gridView4 = null
  let gridView5 = null

  let gridView6 = null
  let gridView7 = null
  let gridView8 = null
  let gridView9 = null

  let provider1 = null
  let provider2 = null
  let provider3 = null
  let provider4 = null
  let provider5 = null

  let provider6 = null
  let provider7 = null
  let provider8 = null
  let provider9 = null

    const fields1 = [
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'rteCd', dataType: 'text' },
    { fieldName: 'porCtrCd', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'polCtrCd', dataType: 'text' },
    { fieldName: 'polPlcCd', dataType: 'text' },
    { fieldName: 'podCtrCd', dataType: 'text' },
    { fieldName: 'podPlcCd', dataType: 'text' },
    { fieldName: 'dlyCtrCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'vslCd', dataType: 'text' },
    { fieldName: 'voyNo', dataType: 'text' },
    { fieldName: 'wvExpCm1Amt', dataType: 'number' },
    { fieldName: 'bsaAdjVal', dataType: 'number' },
    { fieldName: 'bkgTeu', dataType: 'number' },
    { fieldName: 'salAdjVal', dataType: 'number' },
    { fieldName: 'svrExeCq', dataType: 'text' },
    { fieldName: 'svrExePer', dataType: 'text' }
  ]
  const columns1 = [
    { name: 'yearWeek', fieldName: 'yearWeek', header: { text: app.$t('cp.CTRL060P020.006') }, editable: false, width: 50, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    {
      name: 'rteCd',
      fieldName: 'rteCd',
      header: { text: app.$t('cp.CTRL060P020.009') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    { name: 'porCtrCd', fieldName: 'porCtrCd', header: { text: app.$t('cp.CTRL060P020.039') }, editable: false, width: 50, visible: false },
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P020.027') }, editable: false, width: 50, visible: false },
    { name: 'polCtrCd', fieldName: 'polCtrCd', header: { text: app.$t('cp.CTRL060P020.040') }, editable: false, width: 50, visible: false },
    { name: 'polPlcCd', fieldName: 'polPlcCd', header: { text: app.$t('cp.CTRL060P020.007') }, editable: false, width: 50, visible: false },
    { name: 'podCtrCd', fieldName: 'podCtrCd', header: { text: app.$t('cp.CTRL060P020.041') }, editable: false, width: 50, visible: false },
    { name: 'podPlcCd', fieldName: 'podPlcCd', header: { text: app.$t('cp.CTRL060P020.008') }, editable: false, width: 50, visible: false },
    { name: 'dlyCtrCd', fieldName: 'dlyCtrCd', header: { text: app.$t('cp.CTRL060P020.042') }, editable: false, width: 50, visible: false },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P020.028') }, editable: false, width: 50, visible: false },
    {
      name: 'vslCd',
      fieldName: 'vslCd',
      header: { text: app.$t('cp.CTRL060P020.010') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    {
      name: 'voyNo',
      fieldName: 'voyNo',
      header: { text: app.$t('cp.CTRL060P020.011') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    { name: 'wvExpCm1Amt', fieldName: 'wvExpCm1Amt', header: { text: app.$t('cp.CTRL060P020.012') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'bsaAdjVal', fieldName: 'bsaAdjVal', header: { text: app.$t('cp.CTRL060P020.013') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'bkgTeu', fieldName: 'bkgTeu', header: { text: app.$t('cp.CTRL060P020.014') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'salAdjVal', fieldName: 'salAdjVal', header: { text: app.$t('cp.CTRL060P020.015') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'svrExePer', fieldName: 'svrExePer', editable: false, width: 50, visible: false }
  ]

  const fields2 = [
    { fieldName: 'state', dataType: 'text' },
    { fieldName: 'rteCd', dataType: 'text' },
    { fieldName: 'polPlcCd', dataType: 'text' },
    { fieldName: 'podPlcCd', dataType: 'text' },
    { fieldName: 'cgoMd', dataType: 'text' },
    { fieldName: 'endDt', dataType: 'text' },
    { fieldName: 'fulAdjRto', dataType: 'number' },
    { fieldName: 'vepAdjRto', dataType: 'number' }
  ]
  const columns2 = [
    { name: 'rteCd', fieldName: 'rteCd', header: { text: app.$t('cp.CTRL060P020.009') }, width: 40, editor: { type: 'search', searchLength: 5 } },
    { name: 'polPlcCd', fieldName: 'polPlcCd', header: { text: app.$t('cp.CTRL060P020.007') }, width: 40, editor: { type: 'search', searchLength: 5 } },
    { name: 'podPlcCd', fieldName: 'podPlcCd', header: { text: app.$t('cp.CTRL060P020.008') }, width: 40, editor: { type: 'search', searchLength: 5 } },
    { name: 'cgoMd', fieldName: 'cgoMd', header: { text: app.$t('cp.CTRL060P020.029') }, width: 40, editor: { type: 'search', searchLength: 5, values: ['L', 'T'], labels: ['로컬', 'TS'] } },
    { name: 'endDt', fieldName: 'endDt', header: { text: app.$t('cp.CTRL060P020.030') }, width: 70, editor: { type: 'date', datetimeFormat: 'yyyyMMdd', maxLength: 8, yearNavigation: true } },
    { name: 'fulAdjRto', fieldName: 'fulAdjRto', suffix: ' %', header: { text: app.$t('cp.CTRL060P020.016') }, editor: { type: 'number', showStepButton: true, maxIntegerLength: 3, min: 0, max: 100 }, numberFormat: '#,##0.###', width: 50, styleName: 'text_right' },
    { name: 'vepAdjRto', fieldName: 'vepAdjRto', suffix: ' %', header: { text: app.$t('cp.CTRL060P020.017') }, editor: { type: 'number', showStepButton: true, maxIntegerLength: 3, min: 0, max: 100 }, numberFormat: '#,##0.###', width: 50, styleName: 'text_right' }
  ]

  const fields3 = [
    { fieldName: 'state', dataType: 'text' },
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'targetWeek', dataType: 'text' },
    { fieldName: 'vslCd', dataType: 'text' },
    { fieldName: 'voyNo', dataType: 'text' },
    { fieldName: 'rteCd', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'polPlcCd', dataType: 'text' },
    { fieldName: 'podPlcCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'bkgShprCstNo', dataType: 'text' },
    { fieldName: 'bkgShprCstEnm', dataType: 'text' },
    { fieldName: 'wvExpTeu', dataType: 'number' },
    { fieldName: 'distrCm1Std1', dataType: 'number' },
    { fieldName: 'distrCm1Std2', dataType: 'number' },
    { fieldName: 'distrCm1Std3', dataType: 'number' },
    { fieldName: 'bsaAdjVal', dataType: 'number' },
    { fieldName: 'bkgTeu', dataType: 'number' },
    { fieldName: 'salAdjVal', dataType: 'number' },
    { fieldName: 'salesTeam', dataType: 'text' },
    { fieldName: 'altVslVoy', dataType: 'text' },
    { fieldName: 'expCntrSz', dataType: 'text' },
    { fieldName: 'expCntrTyp', dataType: 'text' }
  ]
  const columns3 = [
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P020.027') }, editable: false, width: 20, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    { name: 'polPlcCd', fieldName: 'polPlcCd', header: { text: app.$t('cp.CTRL060P020.007') }, editable: false, width: 20 },
    { name: 'podPlcCd', fieldName: 'podPlcCd', header: { text: app.$t('cp.CTRL060P020.008') }, editable: false, width: 20 },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P020.028') }, editable: false, width: 20 },
    { name: 'bkgShprCstEnm', fieldName: 'bkgShprCstEnm', header: { text: app.$t('cp.CTRL060P020.018') }, editable: false, width: 80, renderer: { showTooltip: true }, styleName: 'text_left' },
    {
      name: 'distrCm1Std1',
      fieldName: 'distrCm1Std1',
      header: { text: app.$t('cp.CTRL060P020.020'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 30,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              if (prod.getValue(i, 'distrCm1Std1') !== undefined) {
                sum += (prod.getValue(i, 'distrCm1Std1') * prod.getValue(i, 'wvExpTeu'))
                sum2 += prod.getValue(i, 'wvExpTeu')
              }
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'distrCm1Std2',
      fieldName: 'distrCm1Std2',
      header: { text: app.$t('cp.CTRL060P020.031'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 40,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              if (prod.getValue(i, 'distrCm1Std2') !== undefined) {
                sum += (prod.getValue(i, 'distrCm1Std2') * prod.getValue(i, 'wvExpTeu'))
                sum2 += prod.getValue(i, 'wvExpTeu')
              }
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'distrCm1Std3',
      fieldName: 'distrCm1Std3',
      header: { text: app.$t('cp.CTRL060P020.036'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 40,
      styleName: 'text_right',
      footer: {
        numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              if (prod.getValue(i, 'distrCm1Std3') !== undefined) {
                sum += (prod.getValue(i, 'distrCm1Std3') * prod.getValue(i, 'wvExpTeu'))
                sum2 += prod.getValue(i, 'wvExpTeu')
              }
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'wvExpTeu',
      fieldName: 'wvExpTeu',
      header: { text: app.$t('cp.CTRL060P020.019') },
      numberFormat: '#,##0.###',
      editable: false,
      width: 35,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var expCntrSz = grid.getValue(dataCell.index.itemIndex, 'expCntrSz')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if (expCntrSz === 'BKG' && yearWeek !== 'BKG') {
          ret.style = { color: 'grey' }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              sum += prod.getValue(i, 'wvExpTeu')
            }
          }

          return sum
        }
      }
    },
    {
      name: 'bsaAdjVal',
      fieldName: 'bsaAdjVal',
      header: { text: app.$t('cp.CTRL060P020.021') },
      editor: { type: 'number', maxIntegerLength: 10 },
      numberFormat: '#,##0.###',
      width: 30,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var bkgShprCstEnm = grid.getValue(dataCell.index.itemIndex, 'bkgShprCstEnm')
        var wvExpTeu = grid.getValue(dataCell.index.itemIndex, 'wvExpTeu')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if ((bkgShprCstEnm !== '임시 Slot') && (dataCell.value !== wvExpTeu)) {
          ret.style = { background: 'pink', color: 'red' }
        } else {
          if (yearWeek !== 'BKG') {
            ret.style = { background: 'yellow' }
          }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              if (prod.getValue(i, 'bsaAdjVal') !== undefined) {
                sum += prod.getValue(i, 'bsaAdjVal')
              }
            }
          }

          return sum
        }
      }
    },
    {
      name: 'bkgTeu',
      fieldName: 'bkgTeu',
      header: { text: app.$t('cp.CTRL060P020.022') },
      numberFormat: '#,##0.###',
      editable: false,
      width: 30,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0.###',
        expression: 'sum',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              sum += prod.getValue(i, 'bkgTeu')
            }
          }

          return sum
        }
      }
    },
    {
      name: 'salAdjVal',
      fieldName: 'salAdjVal',
      header: { text: app.$t('cp.CTRL060P020.023') },
      editor: { type: 'number', maxIntegerLength: 10 },
      numberFormat: '#,##0.###',
      width: 30,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var bkgShprCstEnm = grid.getValue(dataCell.index.itemIndex, 'bkgShprCstEnm')
        var bsaAdjVal = grid.getValue(dataCell.index.itemIndex, 'bsaAdjVal')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if ((bkgShprCstEnm !== '임시 Slot') && (dataCell.value !== bsaAdjVal)) {
          ret.style = { background: '#A9F5BC' }
        } else {
          if (yearWeek !== 'BKG') {
            ret.style = { background: 'yellow' }
          }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bkgShprCstNo') !== 'X_MAN') {
              if (prod.getValue(i, 'salAdjVal') !== undefined) {
                sum += prod.getValue(i, 'salAdjVal')
              }
            }
          }

          return sum
        }
      }
    },
    { name: 'salesTeam', fieldName: 'salesTeam', header: { text: app.$t('cp.CTRL060P020.038'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' },
    { name: 'expCntrTyp', fieldName: 'expCntrTyp', header: { text: app.$t('cp.CTRL060P020.044'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' },
    { name: 'altVslVoy', fieldName: 'altVslVoy', header: { text: app.$t('cp.CTRL060P020.024'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' }
  ]
  const layout3 = [
    {
      name: 'group0',
      header: { visible: false },
      direction: 'horizontal',
      items: [{ column: 'porPlcCd', footerUserSpans: [{ colspan: 2 }] },
          'polPlcCd'
      ]
    },
    'podPlcCd',
    'dlyPlcCd',
    'bkgShprCstEnm',
    'distrCm1Std1',
    'distrCm1Std2',
    'distrCm1Std3',
    'wvExpTeu',
    'bsaAdjVal',
    'bkgTeu',
    'salAdjVal',
    'salesTeam',
    'expCntrTyp'
  ]

  const fields4 = [
    { fieldName: 'pol', dataType: 'text' },
    { fieldName: 'pod1', dataType: 'text' },
    { fieldName: 'pod2', dataType: 'text' },
    { fieldName: 'pod3', dataType: 'text' },
    { fieldName: 'pod4', dataType: 'text' },
    { fieldName: 'pod5', dataType: 'text' },
    { fieldName: 'pod6', dataType: 'text' },
    { fieldName: 'pod7', dataType: 'text' },
    { fieldName: 'pod8', dataType: 'text' },
    { fieldName: 'pod9', dataType: 'text' },
    { fieldName: 'pod10', dataType: 'text' },
    { fieldName: 'prospect', dataType: 'text' },
    { fieldName: 'rob', dataType: 'text' },
    { fieldName: 'teuCapa', dataType: 'text' },
    { fieldName: 'wgtRob', dataType: 'text' },
    { fieldName: 'wgtCapa', dataType: 'text' }
  ]
  const columns4 = [
    { name: 'pol', fieldName: 'pol', header: { text: app.$t('cp.CTRL060P020.025') }, editable: false, width: 60 },
    { name: 'pod1', fieldName: 'pod1', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod2', fieldName: 'pod2', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod3', fieldName: 'pod3', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod4', fieldName: 'pod4', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod5', fieldName: 'pod5', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod6', fieldName: 'pod6', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod7', fieldName: 'pod7', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod8', fieldName: 'pod8', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod9', fieldName: 'pod9', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod10', fieldName: 'pod10', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'prospect', fieldName: 'prospect', header: { text: app.$t('cp.CTRL060P020.019') }, editable: false, width: 50, styleName: 'text_right' },
    { name: 'rob', fieldName: 'rob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'teuCapa', fieldName: 'teuCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtRob', fieldName: 'wgtRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtCapa', fieldName: 'wgtCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' }
  ]
  const layout4 = [
    'pol',
    'pod1',
    'pod2',
    'pod3',
    'pod4',
    'pod5',
    'pod6',
    'pod7',
    'pod8',
    'pod9',
    'pod10',
    'prospect',
    {
      name: app.$t('cp.CTRL060P020.034'),
      items: [
        { column: 'rob' },
        { column: 'teuCapa' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P020.035'),
      items: [
        { column: 'wgtRob' },
        { column: 'wgtCapa' }
      ]
    }
  ]

  const fields5 = [
    { fieldName: 'pol', dataType: 'text' },
    { fieldName: 'bsaPod1', dataType: 'text' },
    { fieldName: 'bsaPod2', dataType: 'text' },
    { fieldName: 'bsaPod3', dataType: 'text' },
    { fieldName: 'bsaPod4', dataType: 'text' },
    { fieldName: 'bsaPod5', dataType: 'text' },
    { fieldName: 'bsaPod6', dataType: 'text' },
    { fieldName: 'bsaPod7', dataType: 'text' },
    { fieldName: 'bsaPod8', dataType: 'text' },
    { fieldName: 'bsaPod9', dataType: 'text' },
    { fieldName: 'bsaPod10', dataType: 'text' },
    { fieldName: 'bsaProspect', dataType: 'text' },
    { fieldName: 'bsaRob', dataType: 'text' },
    { fieldName: 'teuCapa', dataType: 'text' },
    { fieldName: 'bsaWgtRob', dataType: 'text' },
    { fieldName: 'wgtCapa', dataType: 'text' }
  ]
  const columns5 = [
    { name: 'pol', fieldName: 'pol', header: { text: app.$t('cp.CTRL060P020.025') }, editable: false, width: 60 },
    { name: 'bsaPod1', fieldName: 'bsaPod1', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod2', fieldName: 'bsaPod2', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod3', fieldName: 'bsaPod3', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod4', fieldName: 'bsaPod4', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod5', fieldName: 'bsaPod5', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod6', fieldName: 'bsaPod6', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod7', fieldName: 'bsaPod7', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod8', fieldName: 'bsaPod8', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod9', fieldName: 'bsaPod9', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod10', fieldName: 'bsaPod10', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaProspect', fieldName: 'bsaProspect', header: { text: app.$t('cp.CTRL060P020.019') }, editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaRob', fieldName: 'bsaRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'teuCapa', fieldName: 'teuCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'bsaWgtRob', fieldName: 'bsaWgtRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtCapa', fieldName: 'wgtCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' }
  ]
  const layout5 = [
    'pol',
    'bsaPod1',
    'bsaPod2',
    'bsaPod3',
    'bsaPod4',
    'bsaPod5',
    'bsaPod6',
    'bsaPod7',
    'bsaPod8',
    'bsaPod9',
    'bsaPod10',
    'bsaProspect',
    {
      name: app.$t('cp.CTRL060P020.034'),
      items: [
        { column: 'bsaRob' },
        { column: 'teuCapa' }
      ],
      style: { background: '#ffff00' }
    },
    {
      name: app.$t('cp.CTRL060P020.035'),
      items: [
        { column: 'bsaWgtRob' },
        { column: 'wgtCapa' }
      ]
    }
  ]

  const fields6 = [
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'rteCd', dataType: 'text' },
    { fieldName: 'porCtrCd', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'polCtrCd', dataType: 'text' },
    { fieldName: 'polPlcCd', dataType: 'text' },
    { fieldName: 'podCtrCd', dataType: 'text' },
    { fieldName: 'podPlcCd', dataType: 'text' },
    { fieldName: 'dlyCtrCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'vslCd', dataType: 'text' },
    { fieldName: 'voyNo', dataType: 'text' },
    { fieldName: 'wvExpCm1Amt', dataType: 'number' },
    { fieldName: 'bsaAdjVal', dataType: 'number' },
    { fieldName: 'bkgTeu', dataType: 'number' },
    { fieldName: 'salAdjVal', dataType: 'number' },
    { fieldName: 'svrExeCq', dataType: 'text' },
    { fieldName: 'svrExePer', dataType: 'text' }
  ]
  const columns6 = [
    { name: 'yearWeek', fieldName: 'yearWeek', header: { text: app.$t('cp.CTRL060P020.006') }, editable: false, width: 50, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    {
      name: 'rteCd',
      fieldName: 'rteCd',
      header: { text: app.$t('cp.CTRL060P020.009') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    { name: 'porCtrCd', fieldName: 'porCtrCd', header: { text: app.$t('cp.CTRL060P020.039') }, editable: false, width: 50, visible: false },
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P020.027') }, editable: false, width: 50, visible: false },
    { name: 'polCtrCd', fieldName: 'polCtrCd', header: { text: app.$t('cp.CTRL060P020.040') }, editable: false, width: 50, visible: false },
    { name: 'polPlcCd', fieldName: 'polPlcCd', header: { text: app.$t('cp.CTRL060P020.007') }, editable: false, width: 50, visible: false },
    { name: 'podCtrCd', fieldName: 'podCtrCd', header: { text: app.$t('cp.CTRL060P020.041') }, editable: false, width: 50, visible: false },
    { name: 'podPlcCd', fieldName: 'podPlcCd', header: { text: app.$t('cp.CTRL060P020.008') }, editable: false, width: 50, visible: false },
    { name: 'dlyCtrCd', fieldName: 'dlyCtrCd', header: { text: app.$t('cp.CTRL060P020.042') }, editable: false, width: 50, visible: false },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P020.028') }, editable: false, width: 50, visible: false },
    {
      name: 'vslCd',
      fieldName: 'vslCd',
      header: { text: app.$t('cp.CTRL060P020.010') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    {
      name: 'voyNo',
      fieldName: 'voyNo',
      header: { text: app.$t('cp.CTRL060P020.011') },
      editable: false,
      width: 50,
      renderer: { showTooltip: true },
      styleCallback: function (grid, dataCell) {
        var ret = {}

        if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'Y') {
          ret.style = { background: '#81F781' }
        } else if (grid.getValue(dataCell.index.itemIndex, 'svrExeCq') === 'E') {
          ret.style = { background: '#FA5882' }
        } else {
          ret.style = null
        }

        return ret
      }
    },
    { name: 'wvExpCm1Amt', fieldName: 'wvExpCm1Amt', header: { text: app.$t('cp.CTRL060P020.012') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'bsaAdjVal', fieldName: 'bsaAdjVal', header: { text: app.$t('cp.CTRL060P020.013') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'bkgTeu', fieldName: 'bkgTeu', header: { text: app.$t('cp.CTRL060P020.014') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'salAdjVal', fieldName: 'salAdjVal', header: { text: app.$t('cp.CTRL060P020.015') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'svrExePer', fieldName: 'svrExePer', editable: false, width: 50, visible: false }
  ]

  const fields7 = [
    { fieldName: 'state', dataType: 'text' },
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'targetWeek', dataType: 'text' },
    { fieldName: 'vslCd', dataType: 'text' },
    { fieldName: 'voyNo', dataType: 'text' },
    { fieldName: 'rteCd', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'polPlcCd', dataType: 'text' },
    { fieldName: 'podPlcCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'wvExpTeu', dataType: 'number' },
    { fieldName: 'distrCm1Std1', dataType: 'number' },
    { fieldName: 'distrCm1Std2', dataType: 'number' },
    { fieldName: 'distrCm1Std3', dataType: 'number' },
    { fieldName: 'bsaAdjVal', dataType: 'number' },
    { fieldName: 'bkgTeu', dataType: 'number' },
    { fieldName: 'salAdjVal', dataType: 'number' },
    { fieldName: 'salesTeam', dataType: 'text' },
    { fieldName: 'altVslVoy', dataType: 'text' },
    { fieldName: 'expCntrSz', dataType: 'text' },
    { fieldName: 'expCntrTyp', dataType: 'text' },
    { fieldName: 'dataGb', dataType: 'text' }
  ]
  const columns7 = [
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P020.027') }, editable: false, width: 20, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    { name: 'polPlcCd', fieldName: 'polPlcCd', header: { text: app.$t('cp.CTRL060P020.007') }, editable: false, width: 20 },
    { name: 'podPlcCd', fieldName: 'podPlcCd', header: { text: app.$t('cp.CTRL060P020.008') }, editable: false, width: 20 },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P020.028') }, editable: false, width: 20 },
    {
      name: 'distrCm1Std1',
      fieldName: 'distrCm1Std1',
      header: { text: app.$t('cp.CTRL060P020.020'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 30,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'distrCm1Std1') !== undefined) {
              sum += (prod.getValue(i, 'distrCm1Std1') * prod.getValue(i, 'wvExpTeu'))
              sum2 += prod.getValue(i, 'wvExpTeu')
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'distrCm1Std2',
      fieldName: 'distrCm1Std2',
      header: { text: app.$t('cp.CTRL060P020.031'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 40,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'distrCm1Std2') !== undefined) {
              sum += (prod.getValue(i, 'distrCm1Std2') * prod.getValue(i, 'wvExpTeu'))
              sum2 += prod.getValue(i, 'wvExpTeu')
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'distrCm1Std3',
      fieldName: 'distrCm1Std3',
      header: { text: app.$t('cp.CTRL060P020.036'), styleName: 'multi-line-css' },
      numberFormat: '#,##0.###',
      editable: false,
      width: 40,
      styleName: 'text_right',
      footer: {
        numberFormat: '#,##0',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var sum2 = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'distrCm1Std3') !== undefined) {
              sum += (prod.getValue(i, 'distrCm1Std3') * prod.getValue(i, 'wvExpTeu'))
              sum2 += prod.getValue(i, 'wvExpTeu')
            }
          }

          return sum / sum2
        }
      }
    },
    {
      name: 'wvExpTeu',
      fieldName: 'wvExpTeu',
      header: { text: app.$t('cp.CTRL060P020.019') },
      numberFormat: '#,##0.###',
      editable: false,
      width: 35,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var expCntrSz = grid.getValue(dataCell.index.itemIndex, 'expCntrSz')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if (expCntrSz === 'BKG' && yearWeek !== 'BKG') {
          ret.style = { color: 'grey' }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            sum += prod.getValue(i, 'wvExpTeu')
          }

          return sum
        }
      }
    },
    {
      name: 'bsaAdjVal',
      fieldName: 'bsaAdjVal',
      header: { text: app.$t('cp.CTRL060P020.021') },
      editor: { type: 'number', maxIntegerLength: 10 },
      numberFormat: '#,##0.###',
      width: 30,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var wvExpTeu = grid.getValue(dataCell.index.itemIndex, 'wvExpTeu')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if ((dataCell.value !== wvExpTeu)) {
          ret.style = { background: 'pink', color: 'red' }
        } else {
          if (yearWeek !== 'BKG') {
            ret.style = { background: 'yellow' }
          }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'bsaAdjVal') !== undefined) {
              sum += prod.getValue(i, 'bsaAdjVal')
            }
          }

          return sum
        }
      }
    },
    {
      name: 'bkgTeu',
      fieldName: 'bkgTeu',
      header: { text: app.$t('cp.CTRL060P020.022') },
      numberFormat: '#,##0.###',
      editable: false,
      width: 30,
      styleName: 'text_right',
      footer: {
      numberFormat: '#,##0.###',
        expression: 'sum',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            sum += prod.getValue(i, 'bkgTeu')
          }

          return sum
        }
      }
    },
    {
      name: 'salAdjVal',
      fieldName: 'salAdjVal',
      header: { text: app.$t('cp.CTRL060P020.023') },
      editor: { type: 'number', maxIntegerLength: 10 },
      numberFormat: '#,##0.###',
      width: 30,
      styleName: 'text_right',
      styleCallback: function (grid, dataCell) {
        var ret = {}
        var bsaAdjVal = grid.getValue(dataCell.index.itemIndex, 'bsaAdjVal')
        var yearWeek = grid.getValue(dataCell.index.itemIndex, 'yearWeek')

        if ((dataCell.value !== bsaAdjVal)) {
          ret.style = { background: '#A9F5BC' }
        } else {
          if (yearWeek !== 'BKG') {
            ret.style = { background: 'yellow' }
          }
        }

        return ret
      },
      footer: {
        numberFormat: '#,##0.###',
        valueCallback: function (grid, column, footerIndex, columnFooter, value) {
          var sum = 0
          var prod = grid.getDataSource()
          var cnt = prod.getRowCount()

          for (var i = 0; i < cnt; i++) {
            if (prod.getValue(i, 'salAdjVal') !== undefined) {
              sum += prod.getValue(i, 'salAdjVal')
            }
          }

          return sum
        }
      }
    },
    { name: 'salesTeam', fieldName: 'salesTeam', header: { text: app.$t('cp.CTRL060P020.038'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' },
    { name: 'expCntrTyp', fieldName: 'expCntrTyp', header: { text: app.$t('cp.CTRL060P020.044'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' },
    { name: 'altVslVoy', fieldName: 'altVslVoy', header: { text: app.$t('cp.CTRL060P020.024'), styleName: 'multi-line-css' }, editable: false, width: 20, styleName: 'text_center' }
  ]
  const layout7 = [
    {
      name: 'group0',
      header: { visible: false },
      direction: 'horizontal',
      items: [{ column: 'porPlcCd', footerUserSpans: [{ colspan: 2 }] },
          'polPlcCd'
      ]
    },
    'podPlcCd',
    'dlyPlcCd',
    'distrCm1Std1',
    'distrCm1Std2',
    'distrCm1Std3',
    'wvExpTeu',
    'bsaAdjVal',
    'bkgTeu',
    'salAdjVal',
    'salesTeam',
    'expCntrTyp'
  ]

  const fields8 = [
    { fieldName: 'pol', dataType: 'text' },
    { fieldName: 'pod1', dataType: 'text' },
    { fieldName: 'pod2', dataType: 'text' },
    { fieldName: 'pod3', dataType: 'text' },
    { fieldName: 'pod4', dataType: 'text' },
    { fieldName: 'pod5', dataType: 'text' },
    { fieldName: 'pod6', dataType: 'text' },
    { fieldName: 'pod7', dataType: 'text' },
    { fieldName: 'pod8', dataType: 'text' },
    { fieldName: 'pod9', dataType: 'text' },
    { fieldName: 'pod10', dataType: 'text' },
    { fieldName: 'prospect', dataType: 'text' },
    { fieldName: 'rob', dataType: 'text' },
    { fieldName: 'teuCapa', dataType: 'text' },
    { fieldName: 'wgtRob', dataType: 'text' },
    { fieldName: 'wgtCapa', dataType: 'text' }
  ]
  const columns8 = [
    { name: 'pol', fieldName: 'pol', header: { text: app.$t('cp.CTRL060P020.025') }, editable: false, width: 60 },
    { name: 'pod1', fieldName: 'pod1', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod2', fieldName: 'pod2', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod3', fieldName: 'pod3', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod4', fieldName: 'pod4', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod5', fieldName: 'pod5', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod6', fieldName: 'pod6', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod7', fieldName: 'pod7', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod8', fieldName: 'pod8', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod9', fieldName: 'pod9', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'pod10', fieldName: 'pod10', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'prospect', fieldName: 'prospect', header: { text: app.$t('cp.CTRL060P020.019') }, editable: false, width: 50, styleName: 'text_right' },
    { name: 'rob', fieldName: 'rob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'teuCapa', fieldName: 'teuCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtRob', fieldName: 'wgtRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtCapa', fieldName: 'wgtCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' }
  ]
  const layout8 = [
    'pol',
    'pod1',
    'pod2',
    'pod3',
    'pod4',
    'pod5',
    'pod6',
    'pod7',
    'pod8',
    'pod9',
    'pod10',
    'prospect',
    {
      name: app.$t('cp.CTRL060P020.034'),
      items: [
        { column: 'rob' },
        { column: 'teuCapa' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P020.035'),
      items: [
        { column: 'wgtRob' },
        { column: 'wgtCapa' }
      ]
    }
  ]

  const fields9 = [
    { fieldName: 'pol', dataType: 'text' },
    { fieldName: 'bsaPod1', dataType: 'text' },
    { fieldName: 'bsaPod2', dataType: 'text' },
    { fieldName: 'bsaPod3', dataType: 'text' },
    { fieldName: 'bsaPod4', dataType: 'text' },
    { fieldName: 'bsaPod5', dataType: 'text' },
    { fieldName: 'bsaPod6', dataType: 'text' },
    { fieldName: 'bsaPod7', dataType: 'text' },
    { fieldName: 'bsaPod8', dataType: 'text' },
    { fieldName: 'bsaPod9', dataType: 'text' },
    { fieldName: 'bsaPod10', dataType: 'text' },
    { fieldName: 'bsaProspect', dataType: 'text' },
    { fieldName: 'bsaRob', dataType: 'text' },
    { fieldName: 'teuCapa', dataType: 'text' },
    { fieldName: 'bsaWgtRob', dataType: 'text' },
    { fieldName: 'wgtCapa', dataType: 'text' }
  ]
  const columns9 = [
    { name: 'pol', fieldName: 'pol', header: { text: app.$t('cp.CTRL060P020.025') }, editable: false, width: 60 },
    { name: 'bsaPod1', fieldName: 'bsaPod1', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod2', fieldName: 'bsaPod2', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod3', fieldName: 'bsaPod3', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod4', fieldName: 'bsaPod4', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod5', fieldName: 'bsaPod5', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod6', fieldName: 'bsaPod6', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod7', fieldName: 'bsaPod7', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod8', fieldName: 'bsaPod8', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod9', fieldName: 'bsaPod9', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaPod10', fieldName: 'bsaPod10', header: ' ', editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaProspect', fieldName: 'bsaProspect', header: { text: app.$t('cp.CTRL060P020.019') }, editable: false, width: 50, styleName: 'text_right' },
    { name: 'bsaRob', fieldName: 'bsaRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'teuCapa', fieldName: 'teuCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'bsaWgtRob', fieldName: 'bsaWgtRob', header: { text: app.$t('cp.CTRL060P020.026') }, editable: false, width: 40, styleName: 'text_right' },
    { name: 'wgtCapa', fieldName: 'wgtCapa', header: { text: app.$t('cp.CTRL060P020.033') }, editable: false, width: 40, styleName: 'text_right' }
  ]
  const layout9 = [
    'pol',
    'bsaPod1',
    'bsaPod2',
    'bsaPod3',
    'bsaPod4',
    'bsaPod5',
    'bsaPod6',
    'bsaPod7',
    'bsaPod8',
    'bsaPod9',
    'bsaPod10',
    'bsaProspect',
    {
      name: app.$t('cp.CTRL060P020.034'),
      items: [
        { column: 'bsaRob' },
        { column: 'teuCapa' }
      ],
      style: { background: '#ffff00' }
    },
    {
      name: app.$t('cp.CTRL060P020.035'),
      items: [
        { column: 'bsaWgtRob' },
        { column: 'wgtCapa' }
      ]
    }
  ]

  export default {
    name: 'ScenarioResultList',
    components: {
      EBreadcrumbs,
      WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
    },
    data: function () {
      return {
        customComponent: null,
        parentInfo: {
          position: '',
          sal: [],
          sales: []
        },
        mainList: [{}],
        list: [{}],
        param: {
          yearWeek: '',
          territory: '',
          route: '',
          sales: '',
          porCtr: '',
          porPlc: '',
          polCtr: '',
          polPlc: '',
          podCtr: '',
          podPlc: '',
          dlyCtr: '',
          dlyPlc: '',
          routeYn: 'Y',
          porCtrYn: '',
          porPlcCdYn: '',
          polCtrYn: '',
          polPlcCdYn: '',
          podCtrYn: '',
          podPlcCdYn: '',
          dlyCtrYn: '',
          dlyPlcCdYn: '',
          vslCdYn: 'Y',
          voyNoYn: 'Y',
          solverPercent: 80,
          solverParam: '',
          solverGbCd: '1'
        },
        subParam: {
          yearWeek: '',
          sales: '',
          porCtr: '',
          polCtr: '',
          podCtr: '',
          dlyCtr: '',
          porPlc: '',
          polPlc: '',
          podPlc: '',
          dlyPlc: '',
          vslCd: '',
          voyNo: '',
          rteCd: ''
        },
        countryList: [],
        countryList2: [],
        harborList: [],
        harborList2: [],
        harborList3: [],
        harborList4: [],
        gridHarborList: [],
        territorySearchList: [],
        territoryList: [],
        routeSearchList: [],
        routeList: [],
        salesSearchList: [],
        salesList: [],
        yearWeekSearchList: [],
        yearWeekList: [],
        solverParamList: [],
        iccValidList: [],
        poptSearchKeyword: '',
        currentYearWeek: '',
        gridGbCd: '1',
        vslVoyInfo: '선명/항차:',
        prospectTeu: '',
        prospectWgt: '',
        bsaTeu: '',
        bsaWgt: '',
        teuCapa: '',
        wgtCapa: '',
        tapState: 1,
        send: {
          keyInput: {
            yearWeek: [],
            route: [],
            sales: [],
            territory: []
          }
        },
        lowYdSend: {
          lowYdList: []
        },
        bsaSend: {
          bsaList: []
        },
        bsaUser: 'N'
      }
    },
    computed: {
      ...rootComputed
    },
    created () {
      for (const type of ['mousedown', 'click']) {
        window.addEventListener(type, this.cpCustomEvent)
      }

      const arrMonthInfo = this.$ekmtcCommon.getDefaultStEnDt({ startCode: '', startGap: 0, endCode: 'W', endGap: 4 })

      this.currentYearWeek = moment(arrMonthInfo.enDt).format('YYYYWW')

      bsaCommonInfo.bsaRole().then(response => {
      this.bsaUser = response.data.bsaUser
      }).catch(err => {
        console.log(err)
      })
    },
    mounted: function () {
      const $vm = this
      window.func = this
      const grid1 = createGrid('realgrid1', {
        fields: fields1,
        columns: columns1,
        header: { heights: 60 },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 26 } },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: true
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView1 = grid1.gridView
      provider1 = grid1.provider

      const grid2 = createGrid('realgrid2', {
        fields: fields2,
        columns: columns2,
        header: { heights: 29 },
        displayOptions: {
          rowHeight: 29,
          fitStyle: 'even',
          columnMovable: false,
          selectionStyle: 'rows'
        },
        rowIndicator: {
          visible: false
        },
        // 데이터 삭제 시 행 상태만 deleted로 변경
        options: {
          softDeleting: true
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView2 = grid2.gridView
      provider2 = grid2.provider
      gridView2.footers.visible = false

      const grid3 = createGrid('realgrid3', {
        fields: fields3,
        columns: columns3,
        layout: layout3,
        header: { heights: 60 },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          columnMovable: false,
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 26 } },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView3 = grid3.gridView
      provider3 = grid3.provider

      const grid4 = createGrid('realgrid4', {
        fields: fields4,
        columns: columns4,
        layout: layout4,
        header: { heights: [30, 30] },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView4 = grid4.gridView
      provider4 = grid4.provider
      gridView4.footers.visible = false

      const grid5 = createGrid('realgrid5', {
        fields: fields5,
        columns: columns5,
        layout: layout5,
        header: { heights: [30, 30] },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView5 = grid5.gridView
      provider5 = grid5.provider
      gridView5.footers.visible = false

      const grid6 = createGrid('realgrid6', {
        fields: fields6,
        columns: columns6,
        header: { heights: 60 },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 26 } },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: true
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView6 = grid6.gridView
      provider6 = grid6.provider

      const grid7 = createGrid('realgrid7', {
        fields: fields7,
        columns: columns7,
        layout: layout7,
        header: { heights: 60 },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          columnMovable: false,
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 26 } },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView7 = grid7.gridView
      provider7 = grid7.provider

      const grid8 = createGrid('realgrid8', {
        fields: fields8,
        columns: columns8,
        layout: layout8,
        header: { heights: [30, 30] },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView8 = grid8.gridView
      provider8 = grid8.provider
      gridView8.footers.visible = false

      const grid9 = createGrid('realgrid9', {
        fields: fields9,
        columns: columns9,
        layout: layout9,
        header: { heights: [30, 30] },
        displayOptions: {
          rowHeight: 26,
          fitStyle: 'even',
          selectionStyle: 'rows'
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView9 = grid9.gridView
      provider9 = grid9.provider
      gridView9.footers.visible = false

      $vm.getCountryList()
      $vm.getYearWeekList()
      $vm.getGridHarborList()
      $vm.getTerritoryList()
      $vm.getRouteList()
      $vm.getSalesList()

      gridView1.onCellClicked = (_grid, clickData) => {
        if (clickData.cellType === 'data') {
          $vm.getGridInfo(clickData.dataRow)
          $vm.subSelect()
        }
      }

      gridView6.onCellClicked = (_grid, clickData) => {
        if (clickData.cellType === 'data') {
          $vm.getGridInfo(clickData.dataRow)
          $vm.subSelect()
        }
      }

      gridView2.onCurrentRowChanged = function (grid, oldRow, newRow) {
        gridView2.commit()
        var curr = grid.getCurrent()
        var rowState = newRow > -1 ? provider2.getRowState(newRow) : ''
        var editable = (newRow === -1 && curr.itemIndex > -1) || (rowState === 'created')

        //키값은 추가Row만 수정 가능하도록 변경
        gridView2.columnByName('rteCd').editable = editable
        gridView2.columnByName('polPlcCd').editable = editable
        gridView2.columnByName('podPlcCd').editable = editable
        gridView2.columnByName('cgoMd').editable = editable

        gridView2.refresh()
      }

      gridView3.onCurrentRowChanged = function (grid, oldRow, newRow) {
        gridView3.commit()
        var curr = grid.getCurrent()
        var yearWeek = grid.getValue(curr.itemIndex, 'yearWeek')
        var editable = (yearWeek !== 'BKG')

        //키값은 추가Row만 수정 가능하도록 변경
        gridView3.columnByName('bsaAdjVal').editable = editable
        gridView3.columnByName('salAdjVal').editable = editable

        gridView3.refresh()
      }

      gridView3.setRowStyleCallback(function (grid, item, fixed) {
        var ret = {}
        var yearWeek = grid.getValue(item.index, 'yearWeek')

        if (yearWeek === 'BKG') {
          ret.style = { background: '#CED8F6' }
        }
        return ret
      })

      gridView7.onCurrentRowChanged = function (grid, oldRow, newRow) {
        gridView7.commit()
        var curr = grid.getCurrent()
        var yearWeek = grid.getValue(curr.itemIndex, 'yearWeek')
        var editable = (yearWeek !== 'BKG')

        //키값은 추가Row만 수정 가능하도록 변경
        gridView7.columnByName('bsaAdjVal').editable = editable
        gridView7.columnByName('salAdjVal').editable = editable

        gridView7.refresh()
      }

      gridView7.setRowStyleCallback(function (grid, item, fixed) {
        var ret = {}
        var yearWeek = grid.getValue(item.index, 'yearWeek')

        if (yearWeek === 'BKG') {
          ret.style = { background: '#CED8F6' }
        }
        return ret
      })

      gridView1.onShowTooltip = function (grid, idx, value) {
        const columns = ['rteCd', 'vslCd', 'voyNo']
        var toolTip = value
        if (columns.includes(idx.column)) {
          if (grid.getValue(idx.itemIndex, 'svrExePer') !== undefined) {
            toolTip = grid.getValue(idx.itemIndex, 'svrExePer') + ' %'
          } else {
            toolTip = '최저 유지 비율 데이터 없음'
          }
          return toolTip
        }
      }

      gridView6.onShowTooltip = function (grid, idx, value) {
        const columns = ['rteCd', 'vslCd', 'voyNo']
        var toolTip = value
        if (columns.includes(idx.column)) {
          if (grid.getValue(idx.itemIndex, 'svrExePer') !== undefined) {
            toolTip = grid.getValue(idx.itemIndex, 'svrExePer') + ' %'
          } else {
            toolTip = '최저 유지 비율 데이터 없음'
          }
          return toolTip
        }
      }

      gridView3.onShowTooltip = function (grid, idx, value) {
        const columns = ['bkgShprCstEnm']
        if (columns.includes(idx.column)) {
          let breakLine = ''
          let oneLine = ''
          let oneLineByteLength = 0

          for (const token of value) {
            oneLine += token

            // 한글과 한글 외 텍스트의 너비 계산
            const unicode = token.charCodeAt(0)
            if (unicode > 127 || (unicode > 64 && unicode < 91)) {
              oneLineByteLength += 2
            } else {
              oneLineByteLength += 1
            }

            // 조건에 따른 개행
            if (token === '\n' || (token === ' ' && oneLineByteLength > 70)) {
              breakLine += oneLine + (token === '\n' ? '' : ' \n')
              oneLine = ''
              oneLineByteLength = 0
            }
          }
          breakLine += oneLine
          return breakLine
        }
      }

      gridView7.onShowTooltip = function (grid, idx, value) {
        const columns = ['bkgShprCstEnm']
        if (columns.includes(idx.column)) {
          let breakLine = ''
          let oneLine = ''
          let oneLineByteLength = 0

          for (const token of value) {
            oneLine += token

            // 한글과 한글 외 텍스트의 너비 계산
            const unicode = token.charCodeAt(0)
            if (unicode > 127 || (unicode > 64 && unicode < 91)) {
              oneLineByteLength += 2
            } else {
              oneLineByteLength += 1
            }

            // 조건에 따른 개행
            if (token === '\n' || (token === ' ' && oneLineByteLength > 70)) {
              breakLine += oneLine + (token === '\n' ? '' : ' \n')
              oneLine = ''
              oneLineByteLength = 0
            }
          }
          breakLine += oneLine
          return breakLine
        }
      }
    },
    methods: {
      openAlert: function (msg) {
        let obj = {
          alertType: 'simple',
          onClose: this.closeFun,
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$t('cp.COMMON.005'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
      },
      cpCustomEvent (e) {
        const type = e.type

        switch (type) {
          case 'mousedown': {
            // click anywhere
            this.controlPopt()
            break
          }
          case 'dbclick': {
            break
          }
        }
      },
      getCountryList: function () {
        bsaCommonInfo.countryList().then(response => {
          this.countryList = response.data
          this.countryList2 = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList = response.data
          this.param.porPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList2: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList2 = response.data
          this.param.polPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList3: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList3 = response.data
          this.param.podPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList4: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList4 = response.data
          this.param.dlyPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getGridHarborList: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.gridHarborList = response.data

          gridView2.columnByName('polPlcCd').editor = { type: 'search', values: this.gridHarborList.map(row => row.plcCd), labels: this.gridHarborList.map(row => row.plcNm), displayLabels: 'valueLabel' }
          gridView2.columnByName('podPlcCd').editor = { type: 'search', values: this.gridHarborList.map(row => row.plcCd), labels: this.gridHarborList.map(row => row.plcNm), displayLabels: 'valueLabel' }
        }).catch(err => {
          console.log(err)
        })
      },
      async getTerritoryList () {
        await bsaCommonInfo.territoryList().then(response => {
          this.territoryList = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      async getRouteList () {
        const territorys = this.send.keyInput.territory.join(',')
        await bsaCommonInfo.territoryFairwayList(territorys).then(response => {
          this.routeList = response.data

          gridView2.columnByName('rteCd').editor = { type: 'search', values: this.routeList.map(row => row.rteCd), labels: this.routeList.map(row => row.rteNm), displayLabels: 'valueLabel' }
        }).catch(err => {
          console.log(err)
        })
      },
      async getSalesList () {
        await bsaCommonInfo.salesList().then(response => {
          this.salesList = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      async getYearWeekList () {
        await bsaCommonInfo.adjRvnYearWeekList().then(response => {
          this.yearWeekList = response.data
          if (this.yearWeekList.map(row => row.yearWeek).includes(this.currentYearWeek)) {
            this.send.keyInput.yearWeek.push(this.currentYearWeek)
          } else {
            this.send.keyInput.yearWeek.push(String(Math.max(...this.yearWeekList.map(row => row.yearWeek))))
          }
        }).catch(err => {
          console.log(err)
        })
      },
      select: function (val) {
        if (val > 0) {
          this.param.solverGbCd = val
        }
        if (this.send.keyInput.yearWeek.length > 0) {
          this.param.yearWeek = this.send.keyInput.yearWeek.join(',')
        } else {
          this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL060P010.072'), () => {
            return false
          })
        }

        this.param.territory = this.send.keyInput.territory.join(',')
        this.param.route = this.send.keyInput.route.join(',')
        this.param.sales = this.send.keyInput.sales.join(',')

        if (this.tapState === 1) {
          bsaAdjRvnTotal.mainList(this.param).then(response => {
            this.mainList = response.data
            if (this.mainList.length > 0) {
              if (this.param.routeYn === 'Y') {
                gridView1.columnByName('rteCd').visible = true
              } else {
                gridView1.columnByName('rteCd').visible = false
              }
              if (this.param.porCtrYn === 'Y') {
                gridView1.columnByName('porCtrCd').visible = true
              } else {
                gridView1.columnByName('porCtrCd').visible = false
              }
              if (this.param.porPlcCdYn === 'Y') {
                gridView1.columnByName('porPlcCd').visible = true
              } else {
                gridView1.columnByName('porPlcCd').visible = false
              }
              if (this.param.polCtrYn === 'Y') {
                gridView1.columnByName('polCtrCd').visible = true
              } else {
                gridView1.columnByName('polCtrCd').visible = false
              }
              if (this.param.polPlcCdYn === 'Y') {
                gridView1.columnByName('polPlcCd').visible = true
              } else {
                gridView1.columnByName('polPlcCd').visible = false
              }
              if (this.param.podCtrYn === 'Y') {
                gridView1.columnByName('podCtrCd').visible = true
              } else {
                gridView1.columnByName('podCtrCd').visible = false
              }
              if (this.param.podPlcCdYn === 'Y') {
                gridView1.columnByName('podPlcCd').visible = true
              } else {
                gridView1.columnByName('podPlcCd').visible = false
              }
              if (this.param.dlyCtrYn === 'Y') {
                gridView1.columnByName('dlyCtrCd').visible = true
              } else {
                gridView1.columnByName('dlyCtrCd').visible = false
              }
              if (this.param.dlyPlcCdYn === 'Y') {
                gridView1.columnByName('dlyPlcCd').visible = true
              } else {
                gridView1.columnByName('dlyPlcCd').visible = false
              }
              if (this.param.vslCdYn === 'Y') {
                gridView1.columnByName('vslCd').visible = true
              } else {
                gridView1.columnByName('vslCd').visible = false
              }
              if (this.param.voyNoYn === 'Y') {
                gridView1.columnByName('voyNo').visible = true
              } else {
                gridView1.columnByName('voyNo').visible = false
              }

              provider1.setRows(this.mainList)
              gridView1.setCurrent({ itemIndex: 0 })
            } else {
              this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G140.044'), () => {
                return false
              })
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          bsaAdjRvnTotal.mainSectionList(this.param).then(response => {
            this.mainList = response.data
            if (this.mainList.length > 0) {
              if (this.param.routeYn === 'Y') {
                gridView6.columnByName('rteCd').visible = true
              } else {
                gridView6.columnByName('rteCd').visible = false
              }
              if (this.param.porCtrYn === 'Y') {
                gridView6.columnByName('porCtrCd').visible = true
              } else {
                gridView6.columnByName('porCtrCd').visible = false
              }
              if (this.param.porPlcCdYn === 'Y') {
                gridView6.columnByName('porPlcCd').visible = true
              } else {
                gridView6.columnByName('porPlcCd').visible = false
              }
              if (this.param.polCtrYn === 'Y') {
                gridView6.columnByName('polCtrCd').visible = true
              } else {
                gridView6.columnByName('polCtrCd').visible = false
              }
              if (this.param.polPlcCdYn === 'Y') {
                gridView6.columnByName('polPlcCd').visible = true
              } else {
                gridView6.columnByName('polPlcCd').visible = false
              }
              if (this.param.podCtrYn === 'Y') {
                gridView6.columnByName('podCtrCd').visible = true
              } else {
                gridView6.columnByName('podCtrCd').visible = false
              }
              if (this.param.podPlcCdYn === 'Y') {
                gridView6.columnByName('podPlcCd').visible = true
              } else {
                gridView6.columnByName('podPlcCd').visible = false
              }
              if (this.param.dlyCtrYn === 'Y') {
                gridView6.columnByName('dlyCtrCd').visible = true
              } else {
                gridView6.columnByName('dlyCtrCd').visible = false
              }
              if (this.param.dlyPlcCdYn === 'Y') {
                gridView6.columnByName('dlyPlcCd').visible = true
              } else {
                gridView6.columnByName('dlyPlcCd').visible = false
              }
              if (this.param.vslCdYn === 'Y') {
                gridView6.columnByName('vslCd').visible = true
              } else {
                gridView6.columnByName('vslCd').visible = false
              }
              if (this.param.voyNoYn === 'Y') {
                gridView6.columnByName('voyNo').visible = true
              } else {
                gridView6.columnByName('voyNo').visible = false
              }

              provider6.setRows(this.mainList)
              gridView6.setCurrent({ itemIndex: 0 })
            } else {
              this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G140.044'), () => {
                return false
              })
            }
          }).catch(err => {
            console.log(err)
          })
        }

        gridView2.commit()
        bsaAdjRvnTotal.detailList_1(this.param).then(response => {
          this.list = response.data

          provider2.setRows(this.list)
          gridView2.setCurrent({ itemIndex: 0 })
        }).catch(err => {
          console.log(err)
        })
      },
      solver: function () {
        if (this.tapState === 1) {
          if (gridView1.getCheckedRows().length !== 0) {
            this.solverParamList = []
            gridView1.getCheckedRows().forEach((row, index) => {
              this.solverParamList.push(provider1.getValue(row, 'rteCd') + provider1.getValue(row, 'vslCd') + provider1.getValue(row, 'voyNo'))
            })
          } else {
            this.openAlert(this.$t('cp.CTRL010G010.017'))
            return
          }
        } else {
          if (gridView6.getCheckedRows().length !== 0) {
            this.solverParamList = []
            gridView6.getCheckedRows().forEach((row, index) => {
              this.solverParamList.push(provider6.getValue(row, 'rteCd') + provider6.getValue(row, 'vslCd') + provider6.getValue(row, 'voyNo'))
            })
          } else {
            this.openAlert(this.$t('cp.CTRL010G010.017'))
            return
          }
        }

        this.param.solverParam = this.solverParamList.join(',')

        if (this.tapState === 1) {
          bsaAdjRvnTotal.solver(this.param).then(response => {
            this.select()
            this.subSelect()
          }).catch(err => {
            console.log(err)
          })
        } else {
          bsaAdjRvnTotal.sectionSolver(this.param).then(response => {
            this.select()
            this.subSelect()
          }).catch(err => {
            console.log(err)
          })
        }
      },
      subSelect: function () {
        gridView3.commit()
        if (this.tapState === 1) {
          bsaAdjRvnTotal.detailList_2(this.subParam).then(response => {
            this.list = response.data

            provider3.setRows(this.list)
            gridView3.setCurrent({ itemIndex: 0 })
          }).catch(err => {
            console.log(err)
          })

          bsaAdjRvnTotal.detailList_3(this.subParam).then(response => {
            this.list = response.data

            if (this.list.length === 1) {
              provider4.clearRows()
              provider5.clearRows()

              return
            }

            this.vslVoyInfo = '선명/항차: ' + this.list[0].vslCd + '/' + this.list[0].voyNo
            this.prospectTeu = this.list[0].totalTeu
            this.prospectWgt = this.list[0].totalWgt
            this.bsaTeu = this.list[0].bsaTotalTeu
            this.bsaWgt = this.list[0].bsaTotalWgt
            this.teuCapa = this.list[0].teuCapa
            this.wgtCapa = this.list[0].wgtCapa

            for (var i = 1; i < 11; i++) {
                if ((typeof this.list[0][`pod${i}`]) === 'string') {
                  gridView4.columnByName(`pod${i}`).visible = true
                  gridView4.columnByName(`pod${i}`).header.text = this.list[0][`pod${i}`]
                } else {
                  gridView4.columnByName(`pod${i}`).visible = false
                  gridView4.columnByName(`pod${i}`).header.text = ' '
                }
                gridView4.columnByName('pod1').visible = false

                if ((typeof this.list[0][`bsaPod${i}`]) === 'string') {
                  gridView5.columnByName(`bsaPod${i}`).visible = true
                  gridView5.columnByName(`bsaPod${i}`).header.text = this.list[0][`bsaPod${i}`]
                } else {
                  gridView5.columnByName(`bsaPod${i}`).visible = false
                  gridView5.columnByName(`bsaPod${i}`).header.text = ' '
                }
                gridView5.columnByName('bsaPod1').visible = false
            }

            this.list.splice(0, 1)

            provider4.setRows(this.list)
            gridView4.setCurrent({ itemIndex: 0 })
            provider5.setRows(this.list)
            gridView5.setCurrent({ itemIndex: 0 })
          }).catch(err => {
            console.log(err)
          })
        } else {
          bsaAdjRvnTotal.detailSectionList_2(this.subParam).then(response => {
            this.list = response.data

            provider7.setRows(this.list)
            gridView7.setCurrent({ itemIndex: 0 })
          }).catch(err => {
            console.log(err)
          })

          bsaAdjRvnTotal.detailSectionList_3(this.subParam).then(response => {
            this.list = response.data

            if (this.list.length === 1) {
              provider8.clearRows()
              provider9.clearRows()

              return
            }

            this.vslVoyInfo = '선명/항차: ' + this.list[0].vslCd + '/' + this.list[0].voyNo
            this.prospectTeu = this.list[0].totalTeu
            this.prospectWgt = this.list[0].totalWgt
            this.bsaTeu = this.list[0].bsaTotalTeu
            this.bsaWgt = this.list[0].bsaTotalWgt
            this.teuCapa = this.list[0].teuCapa
            this.wgtCapa = this.list[0].wgtCapa

            for (var i = 1; i < 11; i++) {
                if ((typeof this.list[0][`pod${i}`]) === 'string') {
                  gridView8.columnByName(`pod${i}`).visible = true
                  gridView8.columnByName(`pod${i}`).header.text = this.list[0][`pod${i}`]
                } else {
                  gridView8.columnByName(`pod${i}`).visible = false
                  gridView8.columnByName(`pod${i}`).header.text = ' '
                }
                gridView8.columnByName('pod1').visible = false

                if ((typeof this.list[0][`bsaPod${i}`]) === 'string') {
                  gridView9.columnByName(`bsaPod${i}`).visible = true
                  gridView9.columnByName(`bsaPod${i}`).header.text = this.list[0][`bsaPod${i}`]
                } else {
                  gridView9.columnByName(`bsaPod${i}`).visible = false
                  gridView9.columnByName(`bsaPod${i}`).header.text = ' '
                }
                gridView9.columnByName('bsaPod1').visible = false
            }

            this.list.splice(0, 1)

            provider8.setRows(this.list)
            gridView8.setCurrent({ itemIndex: 0 })
            provider9.setRows(this.list)
            gridView9.setCurrent({ itemIndex: 0 })
          }).catch(err => {
            console.log(err)
          })
        }
      },
      clickPsel (type) {
      const popt = document.querySelector(`#${type}Popt`)
      const poptSearch = document.querySelector(`#${type}PoptSearch`)

      if (poptSearch) {
        setTimeout(() => {
          poptSearch.focus()
        }, 50)
      }

      this.controlPopt(popt)
      },
      controlPopt (targetPopt) {
        this.poptSearchKeyword = ''

        const poptList = document.querySelectorAll('.cp-popt')
        for (const popt of poptList) {
          if (popt !== targetPopt && !popt.classList.contains('cp-popt--close')) {
            if (popt.id === 'territoryPopt') {
              setTimeout(() => {
                this.getRouteList()
              }, 50)
            }
            popt.classList.add('cp-popt--close')
          }
        }

        if (targetPopt) {
          targetPopt.classList.toggle('cp-popt--close')

          const poptUl = targetPopt.querySelector('ul:last-child')
          for (const poptLi of poptUl.children) {
            if (poptLi.classList.contains('cp-li--selected')) {
              poptUl.scrollTop = (poptLi.offsetTop)
              break
            }
          }
        }
      },
      async clickPopt (type, value) {
        const targetList = this.send.keyInput[type]

        if (!targetList.includes(value)) {
          targetList.push(value)
        } else {
          targetList.splice(targetList.indexOf(value), 1)
        }
      },
      controlPchk (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.yearWeekList
            const yearWeekSearchList = this.yearWeekSearchList
            var cnt = 0

            if (this.send.keyInput[type].length === yearWeekList.length) {
              if (this.send.keyInput[type].length === yearWeekSearchList.length) {
                this.send.keyInput[type] = []
              } else {
                for (const i of this.yearWeekSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              }
            } else {
              for (const i of yearWeekSearchList) {
                if (this.send.keyInput[type].includes(i)) {
                  cnt = cnt + 1
                }
              }

              if (cnt > 0 && cnt === yearWeekSearchList.length) {
                for (const i of this.yearWeekSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              } else {
                for (const i of yearWeekSearchList) {
                  if (!this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].push(i)
                  }
                }
              }
            }

            break
          }
          case type.includes('route'): {
            const routeList = this.routeList
            const routeSearchList = this.routeSearchList
            var routeCnt = 0

            if (this.send.keyInput[type].length === routeList.length) {
              if (this.send.keyInput[type].length === routeSearchList.length) {
                this.send.keyInput[type] = []
              } else {
                for (const i of this.routeSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              }
            } else {
              for (const i of routeSearchList) {
                if (this.send.keyInput[type].includes(i)) {
                  routeCnt = routeCnt + 1
                }
              }

              if (routeCnt > 0 && routeCnt === routeSearchList.length) {
                for (const i of this.routeSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              } else {
                for (const i of routeSearchList) {
                  if (!this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].push(i)
                  }
                }
              }
            }

            break
          }
          case type.includes('territory'): {
            const territoryList = this.territoryList
            const territorySearchList = this.territorySearchList
            var territoryCnt = 0

            if (this.send.keyInput[type].length === territoryList.length) {
              if (this.send.keyInput[type].length === territorySearchList.length) {
                this.send.keyInput[type] = []
              } else {
                for (const i of this.territorySearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              }
            } else {
              for (const i of territorySearchList) {
                if (this.send.keyInput[type].includes(i)) {
                  territoryCnt = territoryCnt + 1
                }
              }

              if (territoryCnt > 0 && territoryCnt === territorySearchList.length) {
                for (const i of this.territorySearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              } else {
                for (const i of territorySearchList) {
                  if (!this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].push(i)
                  }
                }
              }
            }

            break
          }
          case type.includes('sales'): {
            const salesList = this.salesList
            const salesSearchList = this.salesSearchList
            var salesCnt = 0

            if (this.send.keyInput[type].length === salesList.length) {
              if (this.send.keyInput[type].length === salesSearchList.length) {
                this.send.keyInput[type] = []
              } else {
                for (const i of this.salesSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              }
            } else {
              for (const i of salesSearchList) {
                if (this.send.keyInput[type].includes(i)) {
                  salesCnt = salesCnt + 1
                }
              }

              if (salesCnt > 0 && salesCnt === salesSearchList.length) {
                for (const i of this.salesSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              } else {
                for (const i of salesSearchList) {
                  if (!this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].push(i)
                  }
                }
              }
            }

            break
          }
        }
      },
      setLongestText (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.yearWeekList
            const yearWeekLengthList = yearWeekList.map(row => row.yearWeek.length)
            if (yearWeekList?.length === 0) {
              return 0
            } else {
              const longestYearWeekLength = Math.max(...yearWeekLengthList)
              const longestYearWeekIdx = yearWeekLengthList.indexOf(longestYearWeekLength)
              const longestYearWeek = yearWeekList[longestYearWeekIdx].yearWeek

              return longestYearWeek
            }
          }
          case type.includes('route'): {
            const routeList = this.routeList
            const routeLengthList = routeList.map(row => row.rteCd.length)
            if (routeList?.length === 0) {
              return 0
            } else {
              const longestRouteLength = Math.max(...routeLengthList)
              const longestRouteIdx = routeLengthList.indexOf(longestRouteLength)
              const longestRoute = routeList[longestRouteIdx].rteCd

              return longestRoute
            }
          }
          case type.includes('territory'): {
            const territoryList = this.territoryList
            const territoryLengthList = territoryList.map(row => row.terCd.length)
            if (territoryList?.length === 0) {
              return 0
            } else {
              const longestTerritoryLength = Math.max(...territoryLengthList)
              const longestTerritoryIdx = territoryLengthList.indexOf(longestTerritoryLength)
              const longestTerritory = territoryList[longestTerritoryIdx].terCd

              return longestTerritory
            }
          }
          case type.includes('sales'): {
            const salesList = this.salesList
            const salesLengthList = salesList.map(row => row.salUno.length)
            if (salesList?.length === 0) {
              return 0
            } else {
              const longestSalesLength = Math.max(...salesLengthList)
              const longestSalesIdx = salesLengthList.indexOf(longestSalesLength)
              const longestSales = salesList[longestSalesIdx].terCd

              return longestSales
            }
          }
        }
      },
      setPselTxt (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.send.keyInput[type]

            if (yearWeekList?.length >= 1) {
              if (yearWeekList.length > 1) {
                return `(${yearWeekList.length}) ${yearWeekList.at(-1)}`
              } else {
                return yearWeekList[0]
              }
            } else {
              return this.$t('cp.COMMON.002')
            }
          }
          case type.includes('route'): {
            const routeList = this.send.keyInput[type]

            if (routeList?.length >= 1) {
              if (routeList.length > 1) {
                return `(${routeList.length}) ${routeList.at(-1)}`
              } else {
                return routeList[0]
              }
            } else {
              return this.$t('cp.COMMON.002')
            }
          }
          case type.includes('territory'): {
            const territoryList = this.send.keyInput[type]
            const targetMapperTer = Object.fromEntries(this.territoryList.map(row => [row.terCd, row.terNm]))

            if (territoryList?.length >= 1) {
              if (territoryList.length > 1) {
                return `(${territoryList.length}) ${targetMapperTer[territoryList.at(-1)]}`
              } else {
                return targetMapperTer[territoryList[0]]
              }
            } else {
              return this.$t('cp.COMMON.002')
            }
          }
          case type.includes('sales'): {
            const salesList = this.send.keyInput[type]

            if (salesList?.length >= 1) {
              if (salesList.length > 1) {
                return `(${salesList.length}) ${salesList.at(-1)}`
              } else {
                return salesList[0]
              }
            } else {
              return this.$t('cp.COMMON.002')
            }
          }
        }
      },
      searchPopt (type, orgName, orgCode) {
        const keyword = this.poptSearchKeyword.toUpperCase()
        const name = orgName.toUpperCase()
        const code = orgCode.toUpperCase()

        const isHide = !(
          keyword === name.substr(0, keyword.length) ||
          keyword === code.substr(0, keyword.length)
        )

        switch (true) {
          case type.includes('yearWeek'): {
            if (!this.yearWeekSearchList.includes(name)) {
              if (isHide === false) {
                this.yearWeekSearchList.push(name)
              }
            } else {
              if (isHide === true) {
                this.yearWeekSearchList.splice(this.yearWeekSearchList.indexOf(name), 1)
              }
            }

            break
          }
          case type.includes('route'): {
            if (!this.routeSearchList.includes(name)) {
              if (isHide === false) {
                this.routeSearchList.push(name)
              }
            } else {
              if (isHide === true) {
                this.routeSearchList.splice(this.routeSearchList.indexOf(name), 1)
              }
            }

            break
          }
          case type.includes('territory'): {
            if (!this.territorySearchList.includes(name)) {
              if (isHide === false) {
                this.territorySearchList.push(name)
              }
            } else {
              if (isHide === true) {
                this.territorySearchList.splice(this.territorySearchList.indexOf(name), 1)
              }
            }

            break
          }
          case type.includes('sales'): {
            if (!this.salesSearchList.includes(name)) {
              if (isHide === false) {
                this.salesSearchList.push(name)
              }
            } else {
              if (isHide === true) {
                this.salesSearchList.splice(this.salesSearchList.indexOf(name), 1)
              }
            }

            break
          }
        }

        return isHide
      },
      getGridInfo (idx) {
          this.subParam.yearWeek = this.mainList[idx].yearWeek
          this.subParam.sales = this.send.keyInput.sales.join(',')
          this.subParam.porCtr = this.mainList[idx].porCtrCd
          this.subParam.polCtr = this.mainList[idx].polCtrCd
          this.subParam.podCtr = this.mainList[idx].podCtrCd
          this.subParam.dlyCtr = this.mainList[idx].dlyCtrCd
          this.subParam.porPlc = this.mainList[idx].porPlcCd
          this.subParam.polPlc = this.mainList[idx].polPlcCd
          this.subParam.podPlc = this.mainList[idx].podPlcCd
          this.subParam.dlyPlc = this.mainList[idx].dlyPlcCd
          this.subParam.vslCd = this.mainList[idx].vslCd
          this.subParam.voyNo = this.mainList[idx].voyNo
          this.subParam.rteCd = this.mainList[idx].rteCd
      },
      add () {
        gridView2.commit()
        provider2.insertRow(0, { rteCd: '', polPlcCd: '', podPlcCd: '', fulAdjRto: '', vepAdjRto: '' })
        gridView2.setCurrent({ itemIndex: 1 })
        gridView2.setCurrent({ itemIndex: 0 })
      },
      del () {
        gridView2.commit()
        if (gridView2.getCheckedRows().length !== 0) {
          // 기존의 deleted state 초기화 (데이터 길이에 의한 인덱스로 참조)
          gridView2.getJsonRows().forEach((row, idx) => {
            if (provider2.getRowState(idx) === 'deleted') {
              provider2.setRowState(idx, 'none')
            }
          })

          const createRowList = []
          // 체크된 항목에 대하여 deleted state 새롭게 부여 (체크 항목의 위치에 의한 참조)
          gridView2.getCheckedRows().forEach((row, index) => {
            if (provider2.getRowState(row) === 'none') {
              provider2.setRowState(row, 'deleted')
            } else if (provider2.getRowState(row) === 'created') {
              createRowList.push(row)
            }
          })

          let delCount = 0
          for (const i of createRowList) {
            provider2.removeRow(i - delCount)
            delCount = delCount + 1
          }
        } else {
          this.openAlert(this.$t('cp.CTRL010G010.017'))
        }
      },
      async asyncAlert (msg) {
        gridView2.commit()
        let validCnt = 0

        provider2.getAllStateRows().created.forEach((createRow2) => {
          if ((provider2.getValue(createRow2, 'rteCd') === null || provider2.getValue(createRow2, 'rteCd') === '') ||
            (provider2.getValue(createRow2, 'polPlcCd') === null || provider2.getValue(createRow2, 'polPlcCd') === '') ||
            (provider2.getValue(createRow2, 'podPlcCd') === null || provider2.getValue(createRow2, 'podPlcCd') === '') ||
            (provider2.getValue(createRow2, 'cgoMd') === null || provider2.getValue(createRow2, 'cgoMd') === '')
          ) {
            validCnt = validCnt + 1
          }
        })

        if (validCnt === 0) {
          let obj = {
          alertType: 'normal',
          showXclose: true,
          customCloseBtnClass: 'button blue lg',
          customCloseBtnText: this.$t('cp.COMMON.007'),
          customConfirmBtnText: this.$t('cp.COMMON.006'),
          customConfirmBtnClass: 'button blue lg',
          useConfirmBtn: true,
          title: this.$t('cp.CTRL060P020.003'),
          message: msg,
          type: 'info'
          }
          if (await this.$ekmtcCommon.asyncAlert(obj)) {
            this.lowYdSave()
          }
        } else {
          console.log('VALIDATION 오류')
        }
      },
      async asyncAlert2 (msg) {
        let obj = {
          alertType: 'normal',
          showXclose: true,
          customCloseBtnClass: 'button blue lg',
          customCloseBtnText: this.$t('cp.COMMON.007'),
          customConfirmBtnText: this.$t('cp.COMMON.006'),
          customConfirmBtnClass: 'button blue lg',
          useConfirmBtn: true,
          title: this.$t('cp.CTRL060P020.004'),
          message: msg,
          type: 'info'
        }
        if (await this.$ekmtcCommon.asyncAlert(obj)) {
          if (this.tapState === 1) {
            this.bsaSave()
          } else {
            this.bsaSectionSave()
          }
        }
      },
      async asyncAlert3 (msg) {
        let errCnt = 0
        if (this.tapState === 1) {
          if (gridView1.getCheckedRows().length !== 0) {
            this.solverParamList = []
            gridView1.getCheckedRows().forEach((row, index) => {
              if (provider1.getValue(row, 'svrExeCq') === 'Y') {
                this.solverParamList.push(provider1.getValue(row, 'yearWeek') + provider1.getValue(row, 'rteCd') + provider1.getValue(row, 'vslCd') + provider1.getValue(row, 'voyNo'))
              } else {
                errCnt = errCnt + 1
              }
            })
          } else {
            this.openAlert(this.$t('cp.CTRL010G010.017'))
            return
          }
        } else {
          if (gridView6.getCheckedRows().length !== 0) {
            this.solverParamList = []
            gridView6.getCheckedRows().forEach((row, index) => {
              if (provider6.getValue(row, 'svrExeCq') === 'Y') {
                this.solverParamList.push(provider6.getValue(row, 'yearWeek') + provider6.getValue(row, 'rteCd') + provider6.getValue(row, 'vslCd') + provider6.getValue(row, 'voyNo'))
              } else {
                errCnt = errCnt + 1
              }
            })
          } else {
            this.openAlert(this.$t('cp.CTRL010G010.017'))
            return
          }
        }

        if (errCnt > 0) {
          this.openAlert(this.$t('cp.CTRL060P020.056'))
          return
        }

        this.param.solverParam = this.solverParamList.join(',')

        bsaAdjRvnTotal.iccSaveValid(this.param).then(response => {
          this.iccValidList = response.data

          if (this.iccValidList.length > 0) {
            let AlertMessage = 'ICC에 이미 존재하는 BSA정보는 이관할수 없습니다. \n'

            for (var i = 0; i < this.iccValidList.length; i++) {
              AlertMessage = AlertMessage + '항로: ' + this.iccValidList[i].rteCd + ' 선명: ' + this.iccValidList[i].vslCd + ' 항차: ' + this.iccValidList[i].voyNo + '\n'
            }

            this.openAlert(AlertMessage)
          }
        }).catch(err => {
          console.log(err)
        })

        let obj = {
          alertType: 'normal',
          showXclose: true,
          customCloseBtnClass: 'button blue lg',
          customCloseBtnText: this.$t('cp.COMMON.007'),
          customConfirmBtnText: this.$t('cp.COMMON.006'),
          customConfirmBtnClass: 'button blue lg',
          useConfirmBtn: true,
          title: this.$t('cp.CTRL060P020.004'),
          message: msg,
          type: 'info'
        }
        if (await this.$ekmtcCommon.asyncAlert(obj)) {
          if (this.tapState === 1) {
            this.iccSave()
          } else {
            this.iccSectionSave()
          }
        }
      },
      lowYdSave: function () {
        gridView2.commit(false)

        provider2.getAllStateRows().created.forEach((createRow2) => {
          provider2.setValue(createRow2, 'state', 'C')
        })
        provider2.getAllStateRows().updated.forEach((updateRow2) => {
          provider2.setValue(updateRow2, 'state', 'U')
        })
        provider2.getAllStateRows().deleted.forEach((deleteRow2) => {
          provider2.setValue(deleteRow2, 'state', 'D')
        })

        this.lowYdSend.lowYdList = provider2.getJsonRows(0, -1)

        // bsaSend
        bsaAdjRvnTotal.lowYdSave(this.lowYdSend).then(() => {
          this.openAlert(this.$t('cp.CTRL010G010.018'))
          this.select()
        }).catch(err => {
          console.log(err)
        })
      },
      bsaSave: function () {
        gridView3.commit(false)

        provider3.getAllStateRows().created.forEach((createRow2) => {
          provider3.setValue(createRow2, 'state', 'C')
        })
        provider3.getAllStateRows().updated.forEach((updateRow2) => {
          provider3.setValue(updateRow2, 'state', 'U')
        })
        provider3.getAllStateRows().deleted.forEach((deleteRow2) => {
          provider3.setValue(deleteRow2, 'state', 'D')
        })

        this.bsaSend.bsaList = provider3.getJsonRows(0, -1)

        // bsaSend
        bsaAdjRvnTotal.bsaSave(this.bsaSend).then(() => {
          this.openAlert(this.$t('cp.CTRL010G010.018'))
          this.subSelect()
        }).catch(err => {
          console.log(err)
        })
      },
      bsaSectionSave: function () {
        gridView7.commit(false)

        provider7.getAllStateRows().created.forEach((createRow2) => {
          provider7.setValue(createRow2, 'state', 'C')
        })
        provider7.getAllStateRows().updated.forEach((updateRow2) => {
          provider7.setValue(updateRow2, 'state', 'U')
        })
        provider7.getAllStateRows().deleted.forEach((deleteRow2) => {
          provider7.setValue(deleteRow2, 'state', 'D')
        })

        this.bsaSend.bsaList = provider7.getJsonRows(0, -1)

        // bsaSend
        bsaAdjRvnTotal.bsaSectionSave(this.bsaSend).then(() => {
          this.openAlert(this.$t('cp.CTRL010G010.018'))
          this.subSelect()
        }).catch(err => {
          console.log(err)
        })
      },
      iccSave: function () {
        bsaAdjRvnTotal.iccSave(this.param).then(response => {
          this.openAlert(this.$t('cp.CTRL010G010.018'))
        }).catch(err => {
          console.log(err)
        })
      },
      iccSectionSave: function () {
        bsaAdjRvnTotal.iccSectionSave(this.param).then(response => {
          this.openAlert(this.$t('cp.CTRL010G010.018'))
        }).catch(err => {
          console.log(err)
        })
      },
      selectTab (tab) {
        $('.tab li').removeClass('on')

        $('#tab' + tab).addClass('on')

        this.tapState = tab
      }
    }
  }
  </script>
  <style>

.excelTitle {
      font-size: 18px;
      font-weight: bold;
    }

    .cp-td-button {
    width: 100%;
    height: 24px !important;
    text-align: left;
    box-sizing: border-box;
    padding: 0 5px !important;
    color: #000000 !important;
    border: solid 1px #cecece !important;
    border-radius: 0px !important;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAFrGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIgogICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIgogICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgeG1wOkNyZWF0ZURhdGU9IjIwMjMtMDctMjBUMTY6NDM6NDErMDkwMCIKICAgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDctMjdUMTM6NDc6MDQrMDk6MDAiCiAgIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDctMjdUMTM6NDc6MDQrMDk6MDAiCiAgIHBob3Rvc2hvcDpEYXRlQ3JlYXRlZD0iMjAyMy0wNy0yMFQxNjo0Mzo0MSswOTAwIgogICBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIgogICBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiCiAgIGV4aWY6UGl4ZWxYRGltZW5zaW9uPSIyNCIKICAgZXhpZjpQaXhlbFlEaW1lbnNpb249IjI0IgogICBleGlmOkNvbG9yU3BhY2U9IjEiCiAgIHRpZmY6SW1hZ2VXaWR0aD0iMjQiCiAgIHRpZmY6SW1hZ2VMZW5ndGg9IjI0IgogICB0aWZmOlJlc29sdXRpb25Vbml0PSIyIgogICB0aWZmOlhSZXNvbHV0aW9uPSI5Ni8xIgogICB0aWZmOllSZXNvbHV0aW9uPSI5Ni8xIj4KICAgPGRjOnRpdGxlPgogICAgPHJkZjpBbHQ+CiAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5sZW5zPC9yZGY6bGk+CiAgICA8L3JkZjpBbHQ+CiAgIDwvZGM6dGl0bGU+CiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InByb2R1Y2VkIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZmZpbml0eSBQaG90byAyIDIuMS4xIgogICAgICBzdEV2dDp3aGVuPSIyMDIzLTA3LTI3VDEzOjQ3OjA0KzA5OjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cjw/eHBhY2tldCBlbmQ9InIiPz4astIkAAABgmlDQ1BzUkdCIElFQzYxOTY2LTIuMQAAKJF1kc8rRFEUxz8GjR+jUSwUi0lYzWiMmthYjBgKizHKYDPz5peaH6/3RpKtsp2ixMavBX8BW2WtFJGSLWtiw/ScNzM1k8y5nXs+93vvOd17LliCKSWtN7ghnclpAb/PsRhaclhfsdJNAy6aw4quzs5PBqlpXw/UmfHOZdaqfe5fa43GdAXqmoTHFFXLCU8Jz6znVJN3hTuVZDgqfC7s1OSCwvemHinxm8mJEv+YrAUD42BpF3YkqjhSxUpSSwvLy+lLp9aU8n3Ml9himYV5ib3iPegE8OPDwTQTjONliFGZvdIdD4Oyoka+u5g/R1ZyFZlVNtBYJUGSHE5R16R6TGJc9JiMFBtm///2VY8Pe0rVbT5ofDGMj36w7kAhbxjfx4ZROIH6Z7jKVPKzRzDyKXq+ovUdgn0LLq4rWmQPLreh60kNa+GiVC9uicfh/QzaQtBxCy3LpZ6V9zl9hOCmfNUN7B/AgJy3r/wCYPZn43Ablv4AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAHESURBVEiJ7dKxaxphGAbwJ1ViLpVQsPAZiZ6J0A+kdpBmcEqECkVvcW2gTjfkT3DJHyCEbBIQLBRxKAohRdzVQzAiPTgq6WClUM2Zj4J6GSQ506mQ4RKTcyr4jO/D9/744AUWWQQA2u32p3q9fqsoyslT3y49VDYajS+FQuGtpmmrAAgAxnGcJgjCeTgcfj8XUKvVvubz+TcAlpxO58Tj8VwxxlY6nQ4HAIIgdKPR6M4swHpfUSwWXwNAPB7/EYlE3v2bt1qtz9lsdqdcLvOqqm4TQs4eAp4ZDSuVSm8ymTj9fr92dzkABIPBj6FQiOm6zjebzcNZPzAEBoPBOoAVSumFUe/z+X4CAGNszRTAcRwAYDQaPTfqx+PxCwCw2WzXpgBK6QGAX5IkEaO+Wq16AfymlH6fBdx7Rel0WlEUZdPhcFzEYrFvLperxBjbLZVKoX6//9Ltdl8mk8lXpgEASKVS591u1w7AdXdutVohiuJxIBDYnwsAAEmSTmVZ3hoOh8t2u/2G5/k/siyT6XSKRCJx5PV603MBRlFVdTuTyeR1XZ+JmAKeghhe0WNCCDkTRfGDxWJBLpfb6/V6G2Z3LfKf5y+ysa1SVFgtlQAAAABJRU5ErkJggg==') no-repeat center right;
  }

  .cp-td-button.disabled {
    border: 1px solid #e1e1e1 !important;
    color: #b7b7b7 !important;
    background: #f9f9f9 url('data:image/png;base64,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')  no-repeat center right;
  }

  .cp-td-button:active {
    border: 1px solid #003193 !important;
    color: #003193 !important;
  }

  .cp-td-button .cp-short-text {
    display: block;
    width: calc(100% - 16px);
    height: inherit;
    overflow: hidden;
    white-space: nowrap;
  }

  .cp-scroll {
    overflow-y: overlay;
    overflow-x: clip;
  }

  .cp-scroll--auto {
    overflow-y: auto;
  }

  .cp-scroll::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .cp-scroll::-webkit-scrollbar-track {
    background-color: #e3e3e3;
  }

  .cp-grid .cp-scroll::-webkit-scrollbar-track {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-scroll::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 10px;
    border: 5px solid #ffffff00;
  }

  .cp-scroll::-webkit-scrollbar-button {
    display: none;
  }

  .cp-parentnode > h2 {
    margin-top: 8px !important;
    margin-bottom: 0px !important;
  }

  .cp-unitbox {
    position: absolute;
    z-index: 10;
    min-width: 150px;
    border: 1px solid #b4b4b4;
    background-color: #ffffff;
    box-shadow: 0px 12px 26px 6px #a7a7a780;
    user-select: none;
  }

  .cp-unitbox.cp-popt {
    width:150px;
    border-radius: 10px;
  }

  .cp-unitbox > * {
    position: relative;
  }

  .cp-psel {
    text-align: left;
    line-height: 24px;
    cursor: default;
    height: 24px;
    padding: 0 20px 0 5px;
    border: solid 1px #cecece;
    font-size: 13px;
    letter-spacing: -1px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQ2NUMwQjRFRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQ2NUMwQjRGRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDY1QzBCNENGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDY1QzBCNERGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4h6VXxAAAATlBMVEWPj4/o6OiQkJDMzMzOzs7j4+Oamprk5OSSkpKOjo6NjY3Q0NDl5eXHx8fIyMjPz8/m5ubNzc2RkZHLy8vS0tLJycnV1dXn5+f////////PBEJmAAAAGnRSTlP/////////////////////////////////ABQiANoAAABISURBVHjaYpDEARiGlwQvJ7sECLBy8aFKSIgyCADFeRiEJdAkJJiZGCXEGQQlMCQkWDjEhPglsEhIcLOJSGBIDPvQxQQAAQYA98E2rkH8+7gAAAAASUVORK5CYII=) no-repeat right 50%;
    width: 100%;
    font-weight: 300;
    vertical-align: middle;
    font-family: 'Noto Sans KR', sans-serif;
    word-wrap: normal;
    text-transform: none;
    margin: 0;
  }

  .cp-psel:disabled {
    border: 1px solid #e1e1e1;
    color: #b7b7b7 !important;
    background: #f9f9f9 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0M3MDRDRjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0M3MDRERjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDQzcwNEFGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDQzcwNEJGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Bnl+bAAAAKlBMVEXPz8/k5OTOzs7t7e3u7u7s7Ozl5eXm5ubj4+PS0tLn5+fi4uL29vb///9dVj3DAAAADnRSTlP/////////////////AEXA3MgAAABESURBVHja3NDLAYAgEAPRsHwWdei/XfCoqw0wx7xbNH7SXnBZ5a5afwLd8tqzEi8gqVDWHoCmU40PwA8nwPbvxqYAAwAEZRw7sBHRUAAAAABJRU5ErkJggg==) no-repeat right 50% !important;
  }

  .cp-psel::placeholder {
    color: #000000;
  }

  .cp-psel:disabled::placeholder {
    color: #b7b7b7;
  }

  .cp-psel:focus {
    border-color: #0641b8 !important;
    outline: none;
  }

  .cp-popt--close {
    display: none;
  }

  .cp-popt .cp-ul {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-li-header {
    padding: 8px 13px 8px 11px;
  }

  .cp-li-header--condition {
    min-height: 30px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #cecece;
  }

  .cp-realfiltering .cp-li-header {
    background-color: #ffffff;
  }

  .cp-ul {
    max-height: 300px;
    text-align: left;
    font-weight: 400;
    font-size: 13px;
    text-align: left;
    user-select: none;
  }

  .cp-ul--hide {
    height: 1px;
    border-top: 1px solid #cecece;
    padding-right: 15px;
  }

  .cp-ul--hide .cp-li {
    height: inherit;
    color: #ffffff00;
  }

  .cp-ul--blank {
    background-color: #f6f6f6;
  }

  .cp-li {
    white-space: nowrap;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: #ffffff;
  }

  .cp-ul--plc .cp-li {
    padding: 0px 11px 0px 11px;
  }

  .cp-li > span {
    position: relative;
    left: 5px;
  }

  .cp-popt .cp-li:hover,
  .cp-ul--ctr:not(:hover) .cp-li--selected,
  .cp-ul--plc .cp-li--selected,
  .cp-grid .cp-ul:not(:hover) .cp-li--selected,
  .cp-ul--cond .cp-li:hover,
  .cp-ul--vals .cp-li:hover,
  .cp-ul--cond .cp-li--selected,
  .cp-ul--vals .cp-li--selected {
    background-color: #eaebf2 !important;
    color: #075bb9 !important;
  }

  .cp-li--dummy {
    pointer-events: none;
    height: 1px;
  }

  .cp-pchkbox--disabled {
    cursor: default;
    pointer-events: none;
  }

  .cp-pchkbox--disabled:before {
    background-position: 0 -54px !important;
  }

  .cp-pchkbox--hide {
    display: none !important;
  }

  .cp-pchkbox--selected:before {
    background-position: 0 -18px !important;
  }

  .cp-li--hide {
    display: none;
  }

  .yellow-column {
    background: #ffff00;
    text-align: right;
  }

  .multi-line-css {
    white-space: pre !important;
    text-align: center;
  }

  .tbl { width:100%; border-bottom:1px solid #e1e3eb; table-layout:fixed }
  .tbl th { padding:4px 5px 4px 10px; background:#f6f9ff; color:#075bb9; }
  .tbl td { padding:4px 10px 4px 10px;}
  </style>
